import { render, staticRenderFns } from "./Lessons.vue?vue&type=template&id=5db7a6cb&scoped=true"
import script from "./Lessons.vue?vue&type=script&lang=js"
export * from "./Lessons.vue?vue&type=script&lang=js"
import style0 from "./Lessons.vue?vue&type=style&index=0&id=5db7a6cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db7a6cb",
  null
  
)

export default component.exports